import React from 'react';
import { Box } from '@mui/material';
import './SubTitle.css';
import { useTranslation } from 'react-i18next';

export default function SubTitle({
  title,
  path,
  add,
  addPath,
  track,
  trackPath,
  onAddClick,
  onTrackClick
}) {
  const { t } = useTranslation();

  // Function to translate path segments
  const translatePath = (path) => {
    // Split the path into segments
    const segments = path.split('>');
    
    // Translate each segment and join with '>'
    return segments
      .map(segment => t(segment.trim()))
      .join(' > ');
  };

  const handleAddClick = () => {
    if (onAddClick) {
      onAddClick(addPath);
    }
  };

  const handleTrackClick = () => {
    if (onTrackClick) {
      onTrackClick(trackPath);
    }
  };

  return (
    <div className="subtitle-container">
      <div className="subtitle-left-content">
        <Box>
          <span className="subtitle-text">{t(title)}</span>
          <span className="subtitle-path">{translatePath(path)}</span>
        </Box>
      </div>

      <div className="subtitle-buttons">
        {track && (
          <button
            className="subtitle-secondary-btn"
            onClick={handleTrackClick}
            variant="contained"
          >
            {t(track)}
          </button>
        )}

        {add && (
          <button
            className="subtitle-primary-btn"
            onClick={handleAddClick}
            variant="contained"
          >
            {t(add)}
          </button>
        )}
      </div>
    </div>
  );
}